module.exports = __webpack_public_path__ + "img/worried.4c81a9dd.svg";